import Angular from "angular";
import Template from "./wheel-storage-active-icon.html";

export default Angular.module('wheel-storage-active-icon', [])
    .component('wheelStorageActiveIcon', {
        template: Template,
        bindings: {
            storageActive: '<',
            withLabel: '@'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/wheel-storage-active-icon/wheel-storage-active-icon.js